import { render } from "./DettaglioRuolo.vue?vue&type=template&id=39e6ca7e&ts=true"
import script from "./DettaglioRuolo.vue?vue&type=script&lang=ts"
export * from "./DettaglioRuolo.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__